import React from 'react';
import { Editor } from '@tiptap/core';
import { EditorContent } from '@tiptap/react';

import TextStyle from '@tiptap/extension-text-style';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';


import {
  CustomColor,
  CustomParagraph,
  CustomCode,
  CustomHorizontalRule,
  CustomBlockquote,
  CustomOrderedList,
  CustomBulletList,
  CustomImage,
  ImageLinkNode,
  TextTransform,
  TextDecoration,
  FontSize,
  FontWeight,
  CustomLink,
  CustomFontFamily,
  LetterSpacing,
  LineHeight
} from './CustomTiptapExtensions';

import StarterKit from '@tiptap/starter-kit';

import Iframe from './Iframe';

function setupContent(props) {

  const {
    content,
    baseUrlTamplate,
    frameRef
  } = props;

  return {
    editable: false,
    extensions: [
      StarterKit.configure({
        history: false,
        horizontalRule: false,
        codeBlock: false,
        blockquote: false,
        code: false,
        paragraph: false,
        heading: {
          HTMLAttributes: {
            class: 'editor-heading',
          },
          levels: [3]
        }
      }),
      Iframe,
      CustomCode,
      CustomHorizontalRule,
      TextStyle,
      Underline,
      CustomLink(baseUrlTamplate),
      CustomParagraph,
      CustomBlockquote,
      CustomBulletList,
      CustomOrderedList,
      ImageLinkNode,
      CustomFontFamily(frameRef),
      FontSize,
      LetterSpacing,
      LineHeight,
      FontWeight,
      TextTransform,
      TextDecoration,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      CustomImage,
      CustomColor.configure({
        types: ['textStyle'],
      })
    ],
    editorProps: {
      attributes: {
        class: 'Editor'
      }
    },

    content: content
  }
}

function setupEditor(props, element) { 
  return new Editor(setupContent(props, element))
}


class TiptapRender extends React.Component {
  constructor(props) {
    super();
    this.setupEditorContent = setupEditor(props);
  }


  componentWillUnmount() {
    if (this.setupEditorContent) this.setupEditorContent.destroy();
  }

  render() {

    return (
      <EditorContent editor={this.setupEditorContent} />
    );

  }
}


export default TiptapRender;






// import React from 'react';
// import { Editor } from '@tiptap/core';
// import { EditorContent } from '@tiptap/react';
// import { generateHTML } from '@tiptap/html'
// import TextStyle from '@tiptap/extension-text-style';
// import TextAlign from '@tiptap/extension-text-align';
// import Underline from '@tiptap/extension-underline';


// import {
//   CustomColor,
//   CustomParagraph,
//   CustomCode,
//   CustomHorizontalRule,
//   CustomBlockquote,
//   CustomOrderedList,
//   CustomBulletList,
//   CustomImage,
//   ImageLinkNode,
//   TextTransform,
//   TextDecoration,
//   FontSize,
//   FontWeight,
//   CustomLink,
//   CustomFontFamily,
//   LetterSpacing,
//   LineHeight
// } from './CustomTiptapExtensions';

// import StarterKit from '@tiptap/starter-kit';

// import Iframe from './Iframe';


// function validateNodeType(jsonDoc, availableNodes) {
//   // Check if the current node is valid
//   if (!availableNodes.includes(jsonDoc.type)) {
//       return null;
//   }

//   // If the node has content, apply validation to each child
//   if (jsonDoc.content) {
//       // Filter the content array, removing invalid nodes
//       jsonDoc.content = jsonDoc.content
//           .map(child => validateNodeType(child, availableNodes))
//           .filter(child => child !== null);
//   }

//   return jsonDoc;
// }

// const nodes = [
//     'doc',
//     'paragraph',
//     'text',
//     'heading',
//     'bullet_list',
//     'ordered_list',
//     'list_item',
//     'image',
//     'hard_break',
//     'blockquote',
//     // Add any additional custom nodes here
// ]


// function setupContent(props) {

//   try {
//     const {
//       content,
//       baseUrlTamplate,
//       frameRef
//     } = props;
//     if (!content || typeof content === 'string' || content.type !== 'doc') return content;
//     return generateHTML(validateNodeType(content, nodes),[
//       StarterKit.configure({
//         history: false,
//         horizontalRule: false,
//         codeBlock: false,
//         blockquote: false,
//         code: false,
//         paragraph: false,
//         heading: {
//           HTMLAttributes: {
//             class: 'editor-heading',
//           },
//           levels: [3]
//         }
//       }),
//       // Iframe,
//       // CustomCode,
//       // CustomHorizontalRule,
//       // TextStyle,
//       // Underline,
//       // CustomLink(baseUrlTamplate),
//       // CustomParagraph,
//       // CustomBlockquote,
//       // CustomBulletList,
//       // CustomOrderedList,
//       // ImageLinkNode,
//       // CustomFontFamily(frameRef),
//       // FontSize,
//       // LetterSpacing,
//       // LineHeight,
//       // FontWeight,
//       // TextTransform,
//       // TextDecoration,
//       // TextAlign.configure({
//       //   types: ['heading', 'paragraph'],
//       // }),
//       // CustomImage,
//       // CustomColor.configure({
//       //   types: ['textStyle'],
//       // })
//     ])
//   } catch(error) {
//     console.log(error);
//     return;
//   }
// }

// function setupEditor(props, element) { 
//   return setupContent(props, element)
// }


// class TiptapRender extends React.Component {
//   constructor(props) {
//     super();
//     this.setupEditorContent = setupEditor(props);
//   }


//   // componentWillUnmount() {
//   //   if (this.setupEditorContent) this.setupEditorContent.destroy();
//   // }

//   render() {

//     return (
//       this.setupEditorContent
//     );

//   }
// }


// export default TiptapRender;